<!--
    主页
        publicChair 共享陪护椅
 -->

<template>
	<div class="content">
		<div>publicChair 共享陪护椅</div>
	</div>
</template>

<script>
export default {
	name: "",
	components: {},
	data() {
		return {}
	},
	mounted() {},
	methods: {},
}
</script>

<style lang="scss" scoped></style>
